import { mapResultDecisionStatusToColor } from 'KnmErknmPackage/ErknmResultDecisionsModule/constants/mapResultDecisionStatusToColor';
import { KnmResultDecisionStatusEnum } from 'APIPackage/KnmModule/enums/KnmResultDecisionStatusEnum';
import { mapResultDecisionStatusToLabel } from 'KnmErknmPackage/ErknmResultDecisionsModule/constants/mapResultDecisionStatusToLabel';
import { KnmResultDecisionAgreementStatusEnum } from 'APIPackage/KnmModule/enums/KnmResultDecisionAgreementStatusEnum';

import styles from './ResultDecisionStatus.module.scss';
import { mapResultDecisionAgreementStatusToColor } from '../constants/mapResultDecisionAgreementStatusToColor';
import { mapResultDecisionAgreementStatusToLabel } from '../constants/mapResultDecisionAgreementStatusToLabel';

interface IResultDecisionStatusProps {
  status: KnmResultDecisionStatusEnum | undefined;
  agreementStatus: KnmResultDecisionAgreementStatusEnum | undefined;
  isPaperless: boolean;
  isNew: boolean | undefined;
  isPendingD10Cancellation?: boolean;
}

export const ResultDecisionStatus = ({
  status,
  agreementStatus,
  isPaperless,
  isNew,
  isPendingD10Cancellation,
}: IResultDecisionStatusProps) => {
  if (isPaperless && isNew) {
    return <div className={styles.ActStatus}>Черновик</div>;
  }

  if (!status) {
    return null;
  }

  if (isPendingD10Cancellation) {
    return (
      <div className={styles.Wrapper}>
        <div className={styles.ResultDecisionStatus} data-color="yellow">
          Ожидает отмены
        </div>
      </div>
    );
  }

  return (
    <div className={styles.Wrapper}>
      {!!agreementStatus && (
        <div
          className={styles.ResultDecisionStatus}
          data-color={mapResultDecisionAgreementStatusToColor[agreementStatus]}
        >
          {mapResultDecisionAgreementStatusToLabel[agreementStatus]}
        </div>
      )}
      <div className={styles.ResultDecisionStatus} data-color={mapResultDecisionStatusToColor[status]}>
        {mapResultDecisionStatusToLabel[status]}
      </div>
    </div>
  );
};
